import { Project } from '@arra/core';
import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined';
import { CircularProgress, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostHog } from 'posthog-js/react';
import { authenticatedFetch } from '../../authentication/authenticatedFetch';
import { downloadFile } from '../../project/ProjectsUtils';
import { HeaderButton, IconContainer } from './Headers';
import { getServiceTypeFromProject } from '../../analytics/posthogEvents';

const DownloadButton = ({
  project,
  isCompact,
  withIcon = false,
}: {
  project: Project;
  isCompact: boolean;
  withIcon?: boolean;
}) => {
  const { t } = useTranslation(['project']);
  const [loading, setLoading] = useState<boolean>(false);
  const posthog = usePostHog();
  const handleDownloadProject = async () => {
    setLoading(true);

    const response = await authenticatedFetch(
      `${process.env.REACT_APP_API_URL}/projects/${project._id}`,
      {
        method: 'GET',
        headers: new Headers({
          Accept: 'application/vnd.ms-excel',
          'Content-Type': 'application/json',
        }),
      },
    );
    const statisticFileBlob = await response.blob();

    const filename = `project_${project._id}_${new Date().toISOString()}.xlsx`;

    downloadFile(statisticFileBlob, filename);
    posthog?.capture('project_download clicked', {
      button_name: 'project_download',
      page_name: 'project',
      model_type: getServiceTypeFromProject(project),
      document_type: 'project_xlsx',
    });
    setLoading(false);
  };
  return (
    <Tooltip title={t('project:download-button.tooltip')}>
      <HeaderButton onClick={handleDownloadProject}>
        {withIcon && (
          <IconContainer >
            <DownloadForOfflineOutlinedIcon style={{ fill: 'white' }}/>
          </IconContainer>
        )}
        {!isCompact && <p className="h6r">{t('project:download-button.label')}</p>}
        {loading && <CircularProgress sx={{ maxWidth: 20, maxHeight: 20 }} />}
      </HeaderButton>
    </Tooltip>
  );
};

export default DownloadButton;
